import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { AppProvider } from "./context/AppContext";
import { FavoritesProvider } from "./context/FavoritesContext.jsx";
import { AuthProvider } from "./context/AuthContext.jsx";
import { initializeGTM } from "./utils/gtm.js";
import { runCacheInvalidation } from "./utils/cacheVersion.js";
import { resetProductsCacheOnReload } from "./utils/resetProductsCacheOnReload.js";
import "./index.css";

// Invalidar caché del cliente si APP_VERSION cambió (debe correr antes de render)
runCacheInvalidation();

// Si el usuario recargó la página (F5, Ctrl+R, etc.), reiniciar el caché de
// productos del catálogo para que no se muestren datos desactualizados.
resetProductsCacheOnReload();

// Inicializar Google Tag Manager según el ambiente
initializeGTM();

ReactDOM.createRoot(document.getElementById("root")).render(
  // <React.StrictMode>
  <AuthProvider>
    <FavoritesProvider>
      <AppProvider>
        <App />
      </AppProvider>
    </FavoritesProvider>
  </AuthProvider>,

  // </React.StrictMode>
);
